import { GridColDef } from "@mui/x-data-grid";

export const eventColumns: GridColDef[] = [

    {
        headerName: 'Titre',
        field: 'Title',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Description',
        field: 'Description',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Conférencier',
        field: 'Speaker',
        type: 'string',
        flex: 1,
    },
    {
        headerName: 'Date de Début',
        field: 'StartDate',
        type: 'date',
        flex: 1,
    },
    {
        headerName: 'Date de Fin',
        field: 'EndDate',
        type: 'date',
        flex: 1,

    },
    {
        headerName: 'Localisation',
        field: 'Location',
        type: 'string',
        flex: 1,

    }
]